import React from 'react';
import './toggle-group.css';

const Item = ({ value, children, icon }) => {
  return (
    <button className="toggle-group-item">
      {icon && <span className="toggle-group-item-icon">{icon}</span>}
      {children}
    </button>
  );
};

export const ToggleGroup = ({ children, value, onValueChange }) => {
  return (
    <div className="toggle-group">
      {React.Children.map(children, child => {
        if (!React.isValidElement(child)) return null;
        
        return React.cloneElement(child, {
          onClick: () => onValueChange(child.props.value),
          className: `toggle-group-item ${child.props.value === value ? 'active' : ''}`
        });
      })}
    </div>
  );
};

ToggleGroup.Item = Item; 